import {postOwnerType} from '../../models/post/postOwnerType';

import request from '../axios';
// TODO:remove
export const getComments = async (type: postOwnerType, pageNumber: number) => {
  const {data}: {data: IComments} = await request.get(
    `/api/v2/store/my-post-comment?page=` +
      pageNumber +
      '&profile_type=' +
      type,
  );
  return data;
};


// TODO: check
export const addCommentAnswer = async (payload: IAddCommentAnswerPayload) => {
  const {data}: {data: IResponse} = await request.post(
    `/api/v2/store/comment-answer`,
    payload,
  );
  return data;
};
